import { type PrimitiveAtom, atom } from 'jotai'
import { atomWithStorage, createJSONStorage } from 'jotai/utils'
import {
    getUserCollectionCompanyId,
    getUserCollectionPointId,
    getUserId,
    getUserMunicipalityId,
} from './helpers'

const storage = createJSONStorage<number | null>(() => sessionStorage)
const userId = getUserId()

function getScopedStorageKey(key: string): string {
    return userId ? `${key}-${userId}` : key
}

const initialMunicipalityId = getUserMunicipalityId()
const initialCollectionCompanyId = getUserCollectionCompanyId()
const initialCollectionPointId = getUserCollectionPointId()

export const selectedCollectionCompanyIdAtom = atomWithStorage<number | null>(
    getScopedStorageKey('collectionCompanyId'),
    initialCollectionCompanyId,
    storage
)

export const selectedMunicipalityIdAtom = atomWithStorage<number | null>(
    getScopedStorageKey('municipalityId'),
    initialMunicipalityId,
    storage
)

export const selectedCollectionPointIdAtom = atomWithStorage<number | null>(
    getScopedStorageKey('collectionPointId'),
    initialCollectionPointId,
    storage
)

export const householdsExportIdAtom = atom<number | null>(null) as PrimitiveAtom<number | null>
export const householdMembersExportIdAtom = atom<number | null>(null) as PrimitiveAtom<number | null>

export const feePayersGenerationIdAtom = atom<number | null>(null) as PrimitiveAtom<number | null>
export const yearlyFeePaymentsGenerationIdAtom = atom<number | null>(null) as PrimitiveAtom<number | null>
export const sendYearlyFeePaymentEmailsIdAtom = atom<number | null>(null) as PrimitiveAtom<number | null>

export const discountAssignInMunicipalityJobIdAtom = atom<number | null>(null) as PrimitiveAtom<number | null>
